"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../axios-client/axios-client.service");
var user_company_cs_operator_const_1 = require("./user-company-cs-operator.const");
/**
 * UserCompanyCSOperator
 * @class
 */
var UserCompanyCSOperator = /** @class */ (function () {
    function UserCompanyCSOperator() {
    }
    /**
     * Returns Car Sharing operator's (`csOperatorUuid`) details
     * @param csOperatorUuid {string}
     * @returns Promise<any>
     */
    UserCompanyCSOperator.prototype.getOperatorDetails = function (csOperatorUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_cs_operator_const_1.USER_COMPANY_CS_OPERATOR_ENDPOINT.getOperatorDetails
            .replace('{{version}}', version)
            .replace('{{csOperatorUuid}}', csOperatorUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
   * Returns operator's (`csOperatorUuid`) Legal Documents
   * @param csOperatorUuid {string}
   * @param language {string}
   * @returns Promise<any>
   */
    UserCompanyCSOperator.prototype.getLegalDocuments = function (csOperatorUuid, version, language) {
        if (version === void 0) { version = 'v1'; }
        if (language === void 0) { language = 'es_ES'; }
        var url = user_company_cs_operator_const_1.USER_COMPANY_CS_OPERATOR_ENDPOINT.getLegalDocuments
            .replace('{{version}}', version)
            .replace('{{csOperatorUuid}}', csOperatorUuid)
            .replace('{{language}}', language);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns list of Validation providers for documents
     * @returns
     */
    UserCompanyCSOperator.prototype.getDocumentValidationProviders = function (version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_cs_operator_const_1.USER_COMPANY_CS_OPERATOR_ENDPOINT.getDocumentValidationProviders.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns "Terms and Conditions" for a given operator (`csOperatorUuid`) in a given language (`language`)
     * @param csOperatorUuid {string}
     * @param language {string}
     * @returns
     */
    UserCompanyCSOperator.prototype.getTermsAndConditions = function (csOperatorUuid, language, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_cs_operator_const_1.USER_COMPANY_CS_OPERATOR_ENDPOINT.getTermsAndConditions
            .replace('{{version}}', version)
            .replace('{{csOperatorUuid}}', csOperatorUuid)
            .replace('{{language}}', language);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    return UserCompanyCSOperator;
}());
/**
 * External UserCompanyCSOperator Class Instance
 * @namespace
 */
exports.userCompanyCSOperator = new UserCompanyCSOperator();
